export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4726.c1c7149c.jpg";